import { defineComponent } from 'vue';
import axios, { AxiosResponse } from 'axios';
import * as bootstrap from "bootstrap";

export class dccore_configblobview {
    public idnum: number = 0;
    public idmember: number = 0;
    public hashid: string = "";
    public emp: number = 0;
    public idsession: string = "";
    public external: boolean = false;
    public hostname: string = "";
    public md5hostname: string = "";
    public ispublish: boolean = false;
    public datesnapshot!: Date;
    public first: boolean = false;
}

export class dccoreview_monitorconf {
    public idnum: number = 0;
    public idmember: number = 0;
    public idsession: string | null = "";
    public hostname: string = "";
    public md5hostname: string = "";
    public expiration: Date | null = null;
    public datecreate: Date | null = null;
    public hashid: string = "";
}


export class dccore_configseoview {
    public  idconfiguser: number = 0;
    public  page: number = 0;
    public  keywords: string = "";
    }

export class GroupeConfigBlobView {
    public emp: number = 0;
    public blobs: dccore_configblobview[] = [];
}



export class ConfigurationViewModel {
    public blobsmon: dccoreview_monitorconf[] = [];
    public blobs: GroupeConfigBlobView[] = [];
    public blobsseo: dccore_configseoview[] = [];
    public lastconfigicon: string = "";
    public  lastconfigname: string = "";
    public  lastconfigurl: string = "";
}
declare var g_initdesc: string;
declare var g_landingpageid: number;
declare var g_lancurrent: string;

export const MixinConfigurationModule = defineComponent({
    data() {
        return {
            blobsmon: [] as dccoreview_monitorconf[],
            blobs: [] as GroupeConfigBlobView[],
            blobsseo: [] as dccore_configseoview[],
            defaultconfigdesc: "",
            landingpageid: 0,
            lancurrent: "",
            lastconfigname: "",
            lastconfigurl:" ",
            lastconfigicon:""
        };
    },
   

    mounted() {
        this.defaultconfigdesc = g_initdesc;
        this.landingpageid = g_landingpageid;
        this.lancurrent = g_lancurrent;
      
        this.LoadConfig();
        if (this.landingpageid == 4)
            this.LoadConfigMon();
      
    },
    methods: {
        LoadConfig() {
            var url = "/api/v1.0/configuration/GetListConfigurations?lancurrent="+this.lancurrent+"&landingpageid=" + this.landingpageid;
            var self = this;
            axios.get<ConfigurationViewModel>(url).then(function (response: AxiosResponse<ConfigurationViewModel>) {
                if (response !== null && response.data !== null) {
                    self.blobs = response.data.blobs;
                    self.blobsseo = response.data.blobsseo;
                    self.lastconfigname = response.data.lastconfigname;
                    self.lastconfigurl = response.data.lastconfigurl;
                    self.lastconfigicon = response.data.lastconfigicon;
                    self.ReloadTooltips();
                }
            });
        },
        LoadConfigMon() {
            var url = "/api/v1.0/configuration/GetListConfigMon";
            var self = this;
            axios.get<ConfigurationViewModel>(url).then(function (response: AxiosResponse<ConfigurationViewModel>) {
                if (response !== null && response.data !== null) {
                    self.blobsmon = response.data.blobsmon;
                    self.ReloadTooltips();
                }
            });
        },
        isTouchDevice() {
            return 'ontouchstart' in window || (window as any)['DocumentTouch'] && document instanceof (window as any)['DocumentTouch'];
        },
        ReloadTooltips() {
            $("[data-bs-toggle='tooltip']").tooltip('hide');
        this.$nextTick(function () {
            if (!this.isTouchDevice()) {
                var tooltipTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="tooltip"]'))
                var tooltipList = tooltipTriggerList.map(function (tooltipTriggerEl) {
                    return new bootstrap.Tooltip(tooltipTriggerEl)
                });
            }
            else
                $('[data-bs-toggle="tooltip"]').removeAttr("title");
        });
    },
        DCDeleteConfig(idconfiguser: number, machine: number, descconfirm: string) {
            let choice: boolean = confirm(descconfirm);
            if (!choice)
                return;
            let url: string = "/api/v1.0/DetecterConfig/DeleteConfSnap?machine=" + machine + "&idconfiguser=" + idconfiguser;
            let self = this;
            axios.delete<boolean>(url).then(function (response: AxiosResponse<boolean>) {
                if (response.data) {
                    self.LoadConfig();
                }
            });
        },
        DeleteConfig(blob: dccore_configblobview,descconfirm:string) {
            this.DCDeleteConfig(blob.idnum, blob.emp, descconfirm);

        },
         GetDescSeo(id: number): string {
            for (let blob of this.blobsseo) {
                if (blob.idconfiguser == id)
                    return blob.keywords;
            }
             return this.defaultconfigdesc;
        }
    }

});